import { ApiService } from '@/api';
import { GeekItemForLeaderboard } from '@/models';
import { GeekProfileGeneralPosition } from '@/models/dashboard';
import { GeekProfileGeneralScore, GeekSkill } from '@/models/geek-profile';
import { LeaderboardFilters, PersonalBest } from '@/models/leaderboard';

export const LEADERBOARD_GEEKS_LIMIT = 10;

export class ScoresApi {
  private readonly geeksBaseUrl = '/api/geeks';

  public async fetchGeekGeneralScore(seasonId: string, geekId: string): Promise<GeekProfileGeneralScore> {
    const response = await ApiService.get(
      `${this.geeksBaseUrl}/${geekId}/general-score`,
      {params: {seasonId}},
    );

    return response.json();
  }

  public async fetchGeekGeneralPosition(geekId: string = 'self'): Promise<GeekProfileGeneralPosition> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${geekId}/general-position`);

    return response.json();
  }

  public async fetchGeekSkillScores(seasonId: string, geekId: string): Promise<GeekSkill[]> {
    const response = await ApiService.get(
      `${this.geeksBaseUrl}/${geekId}/skill-scores`,
      {params: {seasonId}},
    );

    return response.json();
  }

  public async fetchGeekPersonalBest(seasonId: string, geekId: string): Promise<PersonalBest> {
    const response = await ApiService.get(
      `${this.geeksBaseUrl}/${geekId}/skills/personal-best`,
      {params: {seasonId}},
    );

    return response.json();
  }

  public async getLeaderboard(
    filters: LeaderboardFilters,
    offset: number,
    limit: number = LEADERBOARD_GEEKS_LIMIT,
  ): Promise<{ data: GeekItemForLeaderboard[], totalCount: number }> {
    const response = await ApiService.get(
      `${this.geeksBaseUrl}/leaderboard`,
      {
        params: {
          offset,
          limit,
          ...filters,
        },
      },
    );

    const data: GeekItemForLeaderboard[] = await response.json();
    const totalCount: number = parseInt(response.headers.get('x-items-count') as string, 10);

    return new Promise((resolve) => resolve({ data, totalCount }));
  }

}
